import { MutationTree } from "vuex";
import Vue from "vue";
import { ScenariosState } from "./types";
import { ScenarioAction } from "@/components/scenarios/types";

export const mutations: MutationTree<ScenariosState> = {
    addAction(state, action: ScenarioAction) {
        state.actions.unshift(action);
    },
    updateAction(state, payload: { index: number; action: ScenarioAction }) {
        Vue.set(state.actions, payload.index, payload.action);
    },
    removeAction(state, index: number) {
        Vue.delete(state.actions, index);
    },
    swapActions(state, payload: { from: number; to: number }) {
        const moved = state.actions[payload.to];
        Vue.set(state.actions, payload.to, state.actions[payload.from]);
        Vue.set(state.actions, payload.from, moved);
    },
    clearActions(state) {
        state.actions = [];
    },
};
